$(document).on('click', '.thickbox', function(e) {
    e.preventDefault();
    var cont = $(this).data('cont');
    $('#overlay').toggleClass('active');
    //$('body').toggleClass('fixed');
    $(cont).toggleClass('active');
});

$(document).on('click', '.thickbox_cont .close', function(e) {
    e.preventDefault();
    $(this).parent().parent().removeClass('active');
    $('#overlay').removeClass('active');
    //$('body').removeClass('fixed');
});

$(document).on('click', '.show_card_button', function(e) {
    e.preventDefault();
    $(this).next().addClass('active');
    $('#overlay').addClass('active');
});

$(document).on('click', '.close_pelecard_modal', function(e) {
    e.preventDefault();
    $(this).parent().parent().removeClass('active');
    $('#overlay').removeClass('active');
});

